import * as React from 'react';
import { connect } from 'react-redux';
import {
  Icon,
  IconButton,
  Hero,
  Title,
  NoteList,
  RouteWrapper,
  Section,
  Box,
} from '../../components';

interface Props {
  auth: any;
}

interface State {
  filter: string;
  unresolved: boolean;
}

class Route extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      filter: 'tasks',
      unresolved: undefined,
    };
    this.handleFilter = this.handleFilter.bind(this);
  }

  handleFilter() {
    if (this.state.unresolved) {
      this.setState({ unresolved: undefined });
    } else {
      this.setState({ unresolved: true });
    }
  }

  render() {
    return (
      <RouteWrapper title="Notifications" requireAuth>
        <Hero className="is-small">
          <Title>Notes</Title>
        </Hero>
        <Section>
          <div className="columns">
            <div className="column">
              {this.state.filter === 'tasks' && (
                <NoteList
                  title="My Tasks"
                  unresolved={this.state.unresolved}
                  assignee={this.props.auth.user.id}
                />
              )}
              {this.state.filter === 'mine' && (
                <NoteList
                  title="My Notes"
                  unresolved={this.state.unresolved}
                  author={this.props.auth.user.id}
                />
              )}
              {this.state.filter === 'all' && (
                <NoteList
                  title="All Notes"
                  unresolved={this.state.unresolved}
                />
              )}
            </div>
            <div className="column is-3">
              <Box>
                <aside className="menu">
                  <ul className="menu-list">
                    <li>
                      <a
                        className={
                          this.state.filter === 'tasks' ? 'is-active' : ''
                        }
                        onClick={() => {
                          this.setState({ filter: 'tasks' });
                        }}
                      >
                        <Icon icon="check" /> Assigned to Me
                      </a>
                    </li>
                    <li>
                      <a
                        className={
                          this.state.filter === 'mine' ? 'is-active' : ''
                        }
                        onClick={() => {
                          this.setState({ filter: 'mine' });
                        }}
                      >
                        <Icon icon="user" /> Notes I've Written
                      </a>
                    </li>
                    <li>
                      <a
                        className={
                          this.state.filter === 'all' ? 'is-active' : ''
                        }
                        onClick={() => {
                          this.setState({ filter: 'all' });
                        }}
                      >
                        <Icon icon="comments" /> All Notes
                      </a>
                    </li>
                  </ul>
                </aside>
              </Box>
              <ul className="menu-list">
                <li>
                  <IconButton
                    handleClick={this.handleFilter}
                    icon={this.state.unresolved ? 'check-square' : 'square-o'}
                    className={`is-${
                      this.state.unresolved ? 'primary' : 'default'
                    } is-fullwidth`}
                  >
                    Outstanding
                  </IconButton>
                </li>
              </ul>
            </div>
          </div>
        </Section>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = ({ auth }) => ({
  auth,
});

export default connect(mapStateToProps)(Route);
